import styled from 'styled-components'
import { Button } from 'antd'

export const Enviar = styled(Button)`
  margin-right: 10px;
`
export const Cancelar = styled(Button)`
  margin-left: 10px;
`
